import "./Icon.css";

const PATHS = {
  mail: "M4 6h16v12H4z M4 7l8 6 8-6",
  lock: "M7 11V8a5 5 0 0110 0v3 M6 11h12v9H6z",
  user: "M12 12a4 4 0 100-8 4 4 0 000 8z M4 21a8 8 0 0116 0",
  userPlus:
    "M10 12a4 4 0 100-8 4 4 0 000 8z M2 21a8 8 0 0114-5 M19 8v6 M16 11h6",
  users:
    "M9 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7z M2.5 20a6.5 6.5 0 0113 0 M16 4.5a3.5 3.5 0 010 6.5 M18 14a6 6 0 013.5 6",
  search: "M11 4a7 7 0 100 14 7 7 0 000-14z M16 16l5 5",
  phone:
    "M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2",
  calendar: "M5 5h14v15H5z M5 10h14 M9 3v4 M15 3v4",
  chevronDown: "M6 9l6 6 6-6",
  chevronLeft: "M15 6l-6 6 6 6",
  chevronRight: "M9 6l6 6-6 6",
  arrowRight: "M5 12h14 M13 6l6 6-6 6",
  check: "M5 12.5l4.5 4.5L19 7.5",
  close: "M6 6l12 12M18 6L6 18",
  plus: "M12 5v14 M5 12h14",
  minus: "M5 12h14",
  upload: "M12 16V4 M7 9l5-5 5 5 M5 20h14",
  sidebar: "M4 5h16v14H4z M9.5 5v14",
  link: "M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1 M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1",
  building:
    "M5 21V4h10v17 M15 9h4v12 M3 21h18 M8 8h1 M11 8h1 M8 12h1 M11 12h1 M8 16h1 M11 16h1",
  home: "M4 11l8-7 8 7 M6 9.5V20h12V9.5",
  eye: "M2.5 12s3.5-6.5 9.5-6.5 9.5 6.5 9.5 6.5-3.5 6.5-9.5 6.5S2.5 12 2.5 12z M12 9.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z",
  edit: "M4 20h4L19 9l-4-4L4 16z M13.5 6.5l4 4",
  logout: "M10 4H6a2 2 0 00-2 2v12a2 2 0 002 2h4 M15 16l4-4-4-4 M19 12H9",
  send: "M4 12l16-8-6 16-3-7z M11 13l9-9",
  bell: "M6 16v-5a6 6 0 0112 0v5l1.5 2h-15z M10 20.5a2 2 0 004 0",
  info: "M12 21a9 9 0 100-18 9 9 0 000 18z M12 11v5 M12 8v.01",
  warning: "M12 4L2.5 20h19z M12 10v4.5 M12 17.5v.01",
  trash: "M4 7h16 M9 7V4h6v3 M6 7l1 13h10l1-13 M10 11v6 M14 11v6",
  download: "M12 4v12 M7 11l5 5 5-5 M5 20h14",
  camera: "M4 7h4l2-3h4l2 3h4v13H4z M12 10a3.5 3.5 0 100 7 3.5 3.5 0 000-7z",
  refresh:
    "M20 7v5h-5 M4 17v-5h5 M5 8a8 8 0 0113-3l2 2 M19 16a8 8 0 01-13 3l-2-2",
  copy: "M9 9h11v11H9z M5 15H4V4h11v1",
  checkCircle: "M12 21a9 9 0 100-18 9 9 0 000 18z M8 12.5l2.8 2.8L16 9.5",
  briefcase: "M4 8h16v11H4z M9 8V5h6v3 M4 13h16",
  idCard:
    "M3 6h18v12H3z M8.5 12.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z M5.5 16a3 3 0 016 0 M14 10h4 M14 14h3",
  shield: "M12 3l8 3v6c0 4.5-3.2 7.5-8 9-4.8-1.5-8-4.5-8-9V6z",
  shieldCheck:
    "M12 3l8 3v6c0 4.5-3.2 7.5-8 9-4.8-1.5-8-4.5-8-9V6z M8.5 12l2.5 2.5 4.5-5",
  shieldOff:
    "M3 3l18 18 M9 4l3-1 8 3v6c0 1.5-.4 3-1.2 4.2 M15.5 19.3L12 21c-4.8-1.5-8-4.5-8-9V6l1.5-.6",
  fileText: "M6 3h9l4 4v14H6z M14 3v5h5 M9 13h7 M9 17h5",
  message: "M4 5h16v11H9l-5 4z",
  wallet: "M4 7h15v12H4z M4 7l12-3v3 M15 13h4",
  swap: "M7 4L3 8l4 4 M3 8h14 M17 20l4-4-4-4 M21 16H7",
};

export type IconName = keyof typeof PATHS;

export interface IconProps {
  name: IconName;
  /** pixels; default 20 */
  size?: number;
  className?: string;
  /** set when the icon is the only content of a button */
  label?: string;
}

/** Line icon in the current text color. */
const Icon = ({ name, size = 20, className = "", label }: IconProps) => (
  <svg
    className={`ds-icon ${className}`.trim()}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    role={label ? "img" : undefined}
    aria-label={label}
    aria-hidden={label ? undefined : true}
  >
    <path d={PATHS[name]} />
  </svg>
);

export default Icon;
